module.exports = __webpack_public_path__ + "static/img/rectangle.820a15a8.png";